import { useCallback, useEffect } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import useRoutesHelper from "../../../hooks/useRoutesHelper";
import { getLabeledProductsByReceipt } from "../../../redux/api/receipt.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { clearLabeledProducts } from "../../../redux/reducer/receipt.reducer";
import LabeledProductsHeader from "./components/LabeledProductsHeader";
import LabeledProductsTableAction from "./components/LabeledProductsTableAction";
import {
  getLabeledProductsTableData,
  labeledProductsTableHeader,
} from "./tableConfigs/labeledProductsTableConfig";

function LabeledProducts() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();
  const receptionId = routeParams?.reception;

  const {
    data: { data: products, total },
    isLoading,
  } = useAppSelector((state) => state.receipt.labeledProducts);

  const loadProducts = useCallback(async () => {
    if (!receptionId) return;

    await dispatch(
      getLabeledProductsByReceipt({ idFluxReceptie: receptionId }),
    );
  }, [dispatch, receptionId]);

  useEffect(() => {
    loadProducts();

    return () => {
      dispatch(clearLabeledProducts());
    };
  }, [dispatch, loadProducts]);

  return (
    <TableWidget
      CustomHeaderComponent={LabeledProductsHeader}
      tableHeaderData={labeledProductsTableHeader}
      tableItemsData={getLabeledProductsTableData(products)}
      ActionButtonsComponent={(props: any) => (
        <LabeledProductsTableAction
          {...props}
          receptionId={receptionId}
          onProductAdded={loadProducts}
        />
      )}
      tableLoading={isLoading}
      totalItems={total}
      withGlobalSearch={false}
      withGlobalFilter={false}
      withTablePagination={false}
      showSearchForCategories={false}
    />
  );
}

export default LabeledProducts;
